<script>
import GmapMixin from '../mixins/GmapMixin'

export default {
  mixins: [GmapMixin],
  async mounted () {
    await this.$initializeMap()
  }
}
</script>




// WEBPACK FOOTER //
// src/plugin/components/Gmap.vue